import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { TYPES } from '@antv/l7-core';
import { anchorTranslate, anchorType, applyAnchorClass, bindAll, DOM } from '@antv/l7-utils';
import { EventEmitter } from 'eventemitter3';

var Marker = function (_EventEmitter) {
  _inherits(Marker, _EventEmitter);

  var _super = _createSuper(Marker);

  function Marker(option) {
    var _this;

    _classCallCheck(this, Marker);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "markerOption", void 0);

    _defineProperty(_assertThisInitialized(_this), "defaultMarker", void 0);

    _defineProperty(_assertThisInitialized(_this), "popup", void 0);

    _defineProperty(_assertThisInitialized(_this), "mapsService", void 0);

    _defineProperty(_assertThisInitialized(_this), "sceneSerive", void 0);

    _defineProperty(_assertThisInitialized(_this), "lngLat", void 0);

    _defineProperty(_assertThisInitialized(_this), "scene", void 0);

    _defineProperty(_assertThisInitialized(_this), "added", false);

    _defineProperty(_assertThisInitialized(_this), "eventHandle", function (e) {
      _this.emit(e.type, {
        target: e,
        data: _this.markerOption.extData,
        lngLat: _this.lngLat
      });
    });

    _this.markerOption = _objectSpread(_objectSpread({}, _this.getDefault()), option);
    bindAll(['update', 'onMove', 'onUp', 'addDragHandler', 'onMapClick'], _assertThisInitialized(_this));

    _this.init();

    return _this;
  }

  _createClass(Marker, [{
    key: "getDefault",
    value: function getDefault() {
      return {
        element: undefined,
        anchor: anchorType.BOTTOM,
        offsets: [0, 0],
        color: '#5B8FF9',
        draggable: false
      };
    }
  }, {
    key: "addTo",
    value: function addTo(scene) {
      this.scene = scene;
      this.mapsService = scene.get(TYPES.IMapService);
      this.sceneSerive = scene.get(TYPES.ISceneService);
      var _this$markerOption = this.markerOption,
          element = _this$markerOption.element,
          draggable = _this$markerOption.draggable;
      this.mapsService.getMarkerContainer().appendChild(element);
      this.registerMarkerEvent(element);
      this.mapsService.on('camerachange', this.update);
      this.mapsService.on('viewchange', this.update);
      this.update();
      this.added = true;
      this.emit('added');
      return this;
    }
  }, {
    key: "remove",
    value: function remove() {
      if (this.mapsService) {
        this.mapsService.off('click', this.onMapClick);
        this.mapsService.off('move', this.update);
        this.mapsService.off('moveend', this.update);
        this.mapsService.off('mousedown', this.addDragHandler);
        this.mapsService.off('touchstart', this.addDragHandler);
        this.mapsService.off('mouseup', this.onUp);
        this.mapsService.off('touchend', this.onUp);
      }

      this.unRegisterMarkerEvent();
      this.removeAllListeners();
      var element = this.markerOption.element;

      if (element) {
        DOM.remove(element);
      }

      if (this.popup) {
        this.popup.remove();
      }

      return this;
    }
  }, {
    key: "setLnglat",
    value: function setLnglat(lngLat) {
      this.lngLat = lngLat;

      if (Array.isArray(lngLat)) {
        this.lngLat = {
          lng: lngLat[0],
          lat: lngLat[1]
        };
      }

      if (this.popup) {
        this.popup.setLnglat(this.lngLat);
      }

      this.update();
      return this;
    }
  }, {
    key: "getLnglat",
    value: function getLnglat() {
      return this.lngLat;
    }
  }, {
    key: "getElement",
    value: function getElement() {
      return this.markerOption.element;
    }
  }, {
    key: "setElement",
    value: function setElement(el) {
      var _this2 = this;

      if (!this.added) {
        this.once('added', function () {
          _this2.setElement(el);
        });
        return this;
      }

      var element = this.markerOption.element;

      if (element) {
        DOM.remove(element);
      }

      this.markerOption.element = el;
      this.init();
      this.mapsService.getMarkerContainer().appendChild(el);
      this.registerMarkerEvent(el);
      this.update();
      return this;
    }
  }, {
    key: "openPopup",
    value: function openPopup() {
      var _this3 = this;

      if (!this.added) {
        this.once('added', function () {
          _this3.openPopup();
        });
        return this;
      }

      var popup = this.popup;

      if (!popup) {
        return this;
      }

      if (!popup.isOpen()) {
        popup.addTo(this.scene);
      }

      return this;
    }
  }, {
    key: "closePopup",
    value: function closePopup() {
      var _this4 = this;

      if (!this.added) {
        this.once('added', function () {
          _this4.closePopup();
        });
      }

      var popup = this.popup;

      if (popup) {
        popup.remove();
      }

      return this;
    }
  }, {
    key: "setPopup",
    value: function setPopup(popup) {
      this.popup = popup;

      if (this.lngLat) {
        this.popup.setLnglat(this.lngLat);
      }

      return this;
    }
  }, {
    key: "togglePopup",
    value: function togglePopup() {
      var popup = this.popup;

      if (!popup) {
        return this;
      } else if (popup.isOpen()) {
        popup.remove();
      } else {
        popup.addTo(this.scene);
      }

      return this;
    }
  }, {
    key: "getPopup",
    value: function getPopup() {
      return this.popup;
    }
  }, {
    key: "getOffset",
    value: function getOffset() {
      return this.markerOption.offsets;
    }
  }, {
    key: "setDraggable",
    value: function setDraggable(draggable) {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "isDraggable",
    value: function isDraggable() {
      return this.markerOption.draggable;
    }
  }, {
    key: "getExtData",
    value: function getExtData() {
      return this.markerOption.extData;
    }
  }, {
    key: "setExtData",
    value: function setExtData(data) {
      this.markerOption.extData = data;
    }
  }, {
    key: "update",
    value: function update() {
      if (!this.mapsService) {
        return;
      }

      var _this$markerOption2 = this.markerOption,
          element = _this$markerOption2.element,
          anchor = _this$markerOption2.anchor;
      this.updatePosition();
      DOM.setTransform(element, "".concat(anchorTranslate[anchor]));
    }
  }, {
    key: "onMapClick",
    value: function onMapClick(e) {
      var element = this.markerOption.element;

      if (this.popup && element) {
        this.togglePopup();
      }
    }
  }, {
    key: "updatePosition",
    value: function updatePosition() {
      if (!this.mapsService) {
        return;
      }

      var _this$markerOption3 = this.markerOption,
          element = _this$markerOption3.element,
          offsets = _this$markerOption3.offsets;
      var _this$lngLat = this.lngLat,
          lng = _this$lngLat.lng,
          lat = _this$lngLat.lat;
      var bounds = this.mapsService.getBounds();
      var pos = this.mapsService.lngLatToContainer([lng, lat]);

      if (element) {
        element.style.display = 'block';
        element.style.whiteSpace = 'nowrap';
        var container = this.mapsService.getContainer();
        var containerWidth = 0;
        var containerHeight = 0;

        if (container) {
          containerWidth = container.scrollWidth;
          containerHeight = container.scrollHeight;
        }

        if (Math.abs(bounds[0][0]) > 180 || Math.abs(bounds[1][0]) > 180) {
          if (pos.x > containerWidth) {
            var newPos = this.mapsService.lngLatToContainer([lng - 360, lat]);
            pos.x = newPos.x;
          }

          if (pos.x < 0) {
            var _newPos = this.mapsService.lngLatToContainer([lng + 360, lat]);

            pos.x = _newPos.x;
          }
        }

        if (pos.x > containerWidth || pos.x < 0 || pos.y > containerHeight || pos.y < 0) {
          element.style.display = 'none';
        }

        element.style.left = pos.x + offsets[0] + 'px';
        element.style.top = pos.y - offsets[1] + 'px';
      }
    }
  }, {
    key: "init",
    value: function init() {
      var _this5 = this;

      var element = this.markerOption.element;
      var _this$markerOption4 = this.markerOption,
          color = _this$markerOption4.color,
          anchor = _this$markerOption4.anchor;

      if (!element) {
        this.defaultMarker = true;
        element = DOM.create('div');
        this.markerOption.element = element;
        var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttributeNS(null, 'display', 'block');
        svg.setAttributeNS(null, 'height', '48px');
        svg.setAttributeNS(null, 'width', '48px');
        svg.setAttributeNS(null, 'viewBox', '0 0 1024 1024');
        var path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttributeNS(null, 'd', 'M512 490.666667C453.12 490.666667 405.333333 442.88 405.333333 384 405.333333 325.12 453.12 277.333333 512 277.333333 570.88 277.333333 618.666667 325.12 618.666667 384 618.666667 442.88 570.88 490.666667 512 490.666667M512 85.333333C346.88 85.333333 213.333333 218.88 213.333333 384 213.333333 608 512 938.666667 512 938.666667 512 938.666667 810.666667 608 810.666667 384 810.666667 218.88 677.12 85.333333 512 85.333333Z');
        path.setAttributeNS(null, 'fill', color);
        svg.appendChild(path);
        element.appendChild(svg);
      }

      DOM.addClass(element, 'l7-marker');
      Object.keys(this.markerOption.style || {}).forEach(function (key) {
        var _this5$markerOption, _this5$markerOption2;

        var value = ((_this5$markerOption = _this5.markerOption) === null || _this5$markerOption === void 0 ? void 0 : _this5$markerOption.style) && ((_this5$markerOption2 = _this5.markerOption) === null || _this5$markerOption2 === void 0 ? void 0 : _this5$markerOption2.style[key]);

        if (element) {
          element.style[key] = value;
        }
      });
      element.addEventListener('click', function (e) {
        _this5.onMapClick(e);
      });
      element.addEventListener('click', this.eventHandle);
      applyAnchorClass(element, anchor, 'marker');
    }
  }, {
    key: "registerMarkerEvent",
    value: function registerMarkerEvent(element) {
      element.addEventListener('mousemove', this.eventHandle);
      element.addEventListener('click', this.eventHandle);
      element.addEventListener('mousedown', this.eventHandle);
      element.addEventListener('mouseup', this.eventHandle);
      element.addEventListener('dblclick', this.eventHandle);
      element.addEventListener('contextmenu', this.eventHandle);
      element.addEventListener('mouseover', this.eventHandle);
      element.addEventListener('mouseout', this.eventHandle);
    }
  }, {
    key: "unRegisterMarkerEvent",
    value: function unRegisterMarkerEvent() {
      var element = this.getElement();
      element.removeEventListener('mousemove', this.eventHandle);
      element.removeEventListener('click', this.eventHandle);
      element.removeEventListener('mousedown', this.eventHandle);
      element.removeEventListener('mouseup', this.eventHandle);
      element.removeEventListener('dblclick', this.eventHandle);
      element.removeEventListener('contextmenu', this.eventHandle);
      element.removeEventListener('mouseover', this.eventHandle);
      element.removeEventListener('mouseout', this.eventHandle);
    }
  }, {
    key: "addDragHandler",
    value: function addDragHandler(e) {
      throw new Error('Method not implemented.');
    }
  }, {
    key: "onUp",
    value: function onUp(e) {
      throw new Error('Method not implemented.');
    }
  }]);

  return Marker;
}(EventEmitter);

export { Marker as default };
//# sourceMappingURL=marker.js.map